import { useLocation } from 'react-router';
import useFetch from '../../hooks/useFetch';
import PieChart from './PieChart';
import StackedBarChart from './StackedBarChart';
import TableChart from './TableChart';
import { Link } from 'react-router-dom';

const SupplierDataGraph = () => {

    const { state } = useLocation();

    const { data, isLoading } = useFetch(`reports/GetSellerDashboard/${state.id}`)

    if (isLoading) {
        return (
            <>
                <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
                    <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                        <h1 className="h2"> <i className="fa-solid fa-spinner fa-spin"></i></h1>
                    </div>
                </main>
            </>
        )
    }

    return (
        <>
            <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
                <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                    <h1 className="h2">
                        <Link to="/suppliers">
                            <i className="fa-solid fa-arrow-left"></i>
                        </Link>
                        {state.name} DASHBOARD
                    </h1>

                </div>
                <div className="chart-container">
                    <div className="row">
                        <PieChart data={data} />
                    </div>
                    <div className="row">
                        <StackedBarChart data={data} />
                    </div>
                    <br></br>
                    <div className="row">
                        <table className="table reports-details">
                            <thead>
                                <tr>
                                    <th>Year</th>
                                    <th>Scope 1</th>
                                    <th>Scope 2</th>
                                    <th>Scope 3</th>
                                    <th>Total GHG Emission</th>
                                    <th>Energy Consumed</th>
                                    <th>Total water discharge</th>
                                    <th>Total water recycle</th>
                                    <th>Total water withdraw</th>
                                    <th>Total Hazardous Waste</th>
                                    <th>Total Non Hazardous Waste</th>
                                    <th>Total Recycled Waste</th>
                                </tr>
                            </thead>
                            <tbody>
                                <TableChart data={data} />
                            </tbody>
                        </table>
                    </div>
                </div>
            </main>
        </>
    );
};

export default SupplierDataGraph;
